import { render, staticRenderFns } from "./WebshopTeaAccessories.vue?vue&type=template&id=0436ccf0&scoped=true&"
import script from "./WebshopTeaAccessories.vue?vue&type=script&lang=js&"
export * from "./WebshopTeaAccessories.vue?vue&type=script&lang=js&"
import style0 from "./WebshopTeaAccessories.vue?vue&type=style&index=0&id=0436ccf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0436ccf0",
  null
  
)

export default component.exports